import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import loadingGif from '../gifs/loadingGif.gif';
import './searchBar.css';


class SearchBar extends Component {
    constructor(props) {
        super(props);
        this.state = {  
        links:'x',
        articles:[],
        regexSorter:/\?source=false---------[0-9]/,
        inputString:null,
        load:false,
        stringempty:false,
        error:false
    }
        this.sendSearch=this.sendSearch.bind(this);
        this.handleInputChange=this.handleInputChange.bind(this);
    }

    sendSearch(e){
        // console.log('click kiya re baba');
        if(this.state.inputString!='Search' && this.state.inputString){
        //Load Start
        this.setState({
          load:true
        })
        //Below we call youtube links
        let stx=this.state.inputString,videoObject;
        stx=stx.replace(/ /g,"+");
        stx='https://youtube.com/results?search_query='+stx;
        console.log('youtube search ',stx)
        axios.post('https://know-search-backend.herokuapp.com/scrapeVideos',{
        link:stx 
        }).then((res)=>{      
          videoObject=res.data.videoObject;
          // console.log('videos aai naacho ',res)
        }).catch((err)=>{
          this.setState({
            error:true
          });
          // console.log('err aai videos me naacho',err);
        });

        //And we then call Articles

        let str=this.state.inputString;
        str=str.replace(/ /g,"%20");
        str='/search?q='+str;
        axios.post('https://know-search-backend.herokuapp.com/scrapeArticles',{
          link:'https://medium.com'+str
        }).then((res)=>{
          let countLoop=0;
          // console.log('response aaya nacho');
          res.data.finalobject.forEach((elem)=>{
            elem.link=elem.link.replace(/\?source=search_post---------[0-9]/,"");
                elem.link=elem.link.replace(/#--responses/,"");
          })
          let articlesEnd=res.data.finalobject;
          // console.log(articlesEnd,res.data.linkObject);


          if(res.data.linkObject.length!=0)
          res.data.linkObject.forEach(element => {

            console.log('linkObject',element);
            axios.post('https://know-search-backend.herokuapp.com/scrapeArticles',{
              link:element+str
            }).then((response)=>{
              let articles=articlesEnd;
              console.log('link .then ',element,response.data)
              response.data.finalobject.forEach((elem)=>{
                elem.link=elem.link.replace(/\?source=false---------[0-9]/,"");
                elem.link=elem.link.replace(/#--responses/,"");
                let flag=false;
                articles.forEach((element)=>{
                  if(element.link==elem.link){
                    flag=true;
                  }
                })
                if(!flag)
                articles.push(elem);
              })
              countLoop++;

              articlesEnd=articles;
              if(res.data.linkObject.length<3){
                if(countLoop==1){
                  // console.log('countloop hua length ke equal ',articlesEnd,element);
                  console.log('no link object');
                  let propsT=this;
                  function checkFlag() {
                    if(!videoObject) {
                       window.setTimeout(checkFlag, 100); /* this checks the flag every 100 milliseconds*/
                    } else {
                      console.log('no link object and got vids')
                      /* do something*/
                      propsT.setState({
                        load:false
                      })
                      propsT.props.addLinksToStore({articlesEnd:articlesEnd,videoObject:videoObject,searchString:propsT.state.inputString});
                    }
                  }
                  checkFlag();
                }
              }
              else{
              if(countLoop==3){
                // console.log('countloop hua 3 ',articlesEnd,element);
                console.log('links in object');
            let propsT=this;
            function checkFlag() {
              if(!videoObject) {
                 window.setTimeout(checkFlag, 100); /* this checks the flag every 100 milliseconds*/
              } else {
                console.log('no link object and got vids')
                /* do something*/
                propsT.setState({
                  load:false
                })
                propsT.props.addLinksToStore({articlesEnd:articlesEnd,videoObject:videoObject,searchString:propsT.state.inputString});
              }
            }
            checkFlag();
              }
            }
            }).catch((err)=>{
              this.setState({
                error:true
              });
              console.log('Error encountered in loop',err,element)
            })
          });

          else{
            console.log('no link object');
            let propsT=this;
            function checkFlag() {
              if(!videoObject) {
                 window.setTimeout(checkFlag, 100); /* this checks the flag every 100 milliseconds*/
              } else {
                console.log('no link object and got vids')
                /* do something*/
                propsT.setState({
                  load:false
                })
                propsT.props.addLinksToStore({articlesEnd:articlesEnd,videoObject:videoObject,searchString:propsT.state.inputString});
              }
            }
            checkFlag();
          }


        }).catch((err)=>{
          this.setState({
            error:true
          });
          console.log('error encountered',err);
        })
      }
      else{
        this.setState({
          stringempty:true
        })
      }
      }

      handleInputChange(e){
        this.setState({
          inputString:e.target.value
        })
      }
    render() { 
        return ( 
          <div style={{textAlign:'center'}}>
              <div className="searchBase">
                <InputBase placeholder="Search" style={{borderBottom:`solid`,padding:`1vh`,borderColor:`#00b8f5`}} id="mainSearch" onChange={this.handleInputChange}/>
                <IconButton style={{color:`#00b8f5`}} id="searchButton" onClick={this.sendSearch} aria-label="search">
                    <SearchIcon />
                </IconButton>
                </div>
                <Dialog fullWidth style={{textAlign:`center`,padding:`4vw`}} aria-labelledby="simple-dialog-title" open={this.state.load}>
                  <DialogTitle> <div style={{fontSize:`20px`,fontWeight:`600`}} > Please Wait While We Grind The Best Results</div></DialogTitle>
                  <DialogContent><img src={loadingGif} alt="Pacman Loading" /></DialogContent>  
                </Dialog>
                <Dialog fullWidth style={{textAlign:`center`,padding:`4vw`}} aria-labelledby="simple-dialog-title" onClose={()=>{this.setState({stringempty:false})}} open={this.state.stringempty}>
                  <DialogTitle> <div style={{fontSize:`20px`,fontWeight:`600`}} > Invalid Input String</div></DialogTitle>
                  <DialogContent>Please Make Sure you enter Something in the Search Field</DialogContent>  
                </Dialog>
                <Dialog fullWidth style={{textAlign:`center`,padding:`4vw`}} aria-labelledby="simple-dialog-title" open={this.state.error} onClose={()=>{window.location.reload()}}>
                  <DialogTitle> <div style={{fontSize:`20px`,fontWeight:`600`}} > We are terribly sorry but we encountered some error in out Search.</div></DialogTitle>
                  <DialogContent>Our Developer has been informed and will fix the error. Please try again after some time. Make sure you checkout some articles by us.</DialogContent>  
                </Dialog>
          </div>     
         );
    }
}

const mapStateToProps = (state) => {
  //console.log('i am called when store is updated',state)

  return {
    state: state
  };
}

const mapDispatchToProps=(dispatch)=>{
return ({
  addLinksToStore:(payload1)=>{dispatch({type:'ADD_LINKS',payload:payload1})},
  loadingStore:()=>{dispatch({type:'LOAD_LINKS'})}
})
}
 
export default connect(mapStateToProps,mapDispatchToProps)(SearchBar);


// WEBPACK FOOTER //
// ./src/components/SearchBar.js